import React, { useState, useEffect, forwardRef } from "react";

import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import instance, { getErrorMessage } from "api/definitions";

const sortListByLabel = (currentList) => {
  const newList = [...currentList].sort((a, b) => {
    return a.label.localeCompare(b.label);
  });
  return newList;
};

const SelectCategory = forwardRef((props, ref) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [category, setCategory] = useState([]);
  const [errorCategory, setErrorCategory] = useState(null);

  const handleChange = (event, newValue) => {
    setCategory(newValue);

    props.parentCallback(newValue);
  };

  useEffect(() => {
    setCategory(props.dataParentToChild);
    setErrorCategory(props.errorParentToChild);

    instance
      .get("categoria")
      .then(function (response) {
        setIsLoaded(true);
        const result = response.data;
        const categories = [];
        result.map((item) =>
          categories.push({ label: item.nome, id: item.id })
        );
        setItems(sortListByLabel(categories));
      })
      .catch(function (error) {
        setIsLoaded(true);
        const msg = getErrorMessage(error);
        setError(msg);
      });
  }, [props.dataParentToChild, props.errorParentToChild]);

  if (error) {
    return <div>Erro: {error}</div>;
  } else if (!isLoaded) {
    return <CircularProgress />;
  } else {
    return (
      <Autocomplete
        disableClearable
        value={category}
        onChange={handleChange}
        disablePortal
        id="category"
        options={items}
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) =>
          value === undefined ||
          value === "" ||
          option.id === value.id ||
          option.nome === value.nome
        }
        noOptionsText={"Nenhuma cadastrada"}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            margin="dense"
            inputRef={ref}
            error={errorCategory}
            label="Categoria"
          />
        )}
      />
    );
  }
});

export default SelectCategory;
